<template>
  <el-dialog
    v-model="modalVisible"
    :title="'Nuevo cilindro'"
    style="width: 45%"
    center
    @close="closeModal"
  >
    <div class="detail-container">
      <el-row :gutter="24">
        <custom-select
          v-model="cylinder.CilindroTipo"
          :label="'Tipo cilindro'"
          :spanColumn="6"
          :settings="{
            placeholder: 'Seleccionar cilindro',
            inputClass: { 'input-error': !validateCylinderFields.CodigoCilindroTipo },
            options: cilindroTipoList,
          }"
          @update:modelValue="handleTipoCilindroChange"
        >
        </custom-select>
        <custom-input-number
          v-model="cylinder.CantidadMagneticos"
          :label="'Cantidad de magneticos'"
          :spanColumn="7"
          :settings="{
            placeholder: 'Cantidad de magneticos',
            inputClass: 'ancho_total',
            min: 0,
            precision: 0,
            step: 0.01,
            controls: false,
          }"
        ></custom-input-number>
        <custom-input-number
          v-model="cylinder.CantidadCilindros"
          :label="'Cantidad de cilindros'"
          :spanColumn="7"
          :settings="{
            placeholder: 'Cantidad de cilindros',
            inputClass: [
              'ancho_total',
              { 'input-error': !validateCylinderFields.CantidadCilindros },
            ],
            min: 0,
            precision: 0,
            step: 0.01,
            controls: false,
          }"
        ></custom-input-number>
      </el-row>
      <br />
      <el-row :gutter="24">
        <custom-input-number
          v-model="cylinder.CantidadAlmasStamping"
          :label="'Cantidad de almas de stamping'"
          :spanColumn="10"
          :settings="{
            placeholder: 'Cantidad de almas de stamping',
            inputClass: 'ancho_total',
            min: 0,
            precision: 0,
            step: 0.01,
            controls: false,
          }"
        ></custom-input-number>
        <custom-input-number
          v-model="cylinder.CantidadCilindrosRelieveEnLinea"
          :label="'Cantidad de cilindros de relieve en línea'"
          :spanColumn="10"
          :settings="{
            placeholder: 'Cantidad de cilindros de relieve en línea',
            inputClass: 'ancho_total',
            min: 0,
            precision: 0,
            step: 0.01,
            controls: false,
          }"
        ></custom-input-number>
      </el-row>
      <el-row :gutter="24">
        <el-col
          :span="12"
          style="margin-top: 2%; margin-block: 2%"
        >
          <div class="custom-label">Engranaje</div>
          <el-select
            v-model="cylinder.CodigoDesarrollo"
            :class="{ 'input-error': !validateCylinderFields.CodigoDesarrollo }"
            style="width: 100%"
            size="default"
            clearable
            filterable
            remote
            :remote-method="fetchEngranaje"
            :loading="isLoading"
            placeholder="Seleccionar engranaje"
            @update:modelValue="handleEnganajeChange"
          >
            <el-option
              v-for="desarrollo in desarrollos"
              :key="desarrollo.Codigo"
              :value="desarrollo.Codigo"
              :label="`Engranaje: ${desarrollo.Engranaje} - Paso: ${desarrollo.Paso} - Des: ${desarrollo.Desarrollo}`"
            >
              <span style="float: left">{{ desarrollo.Engranaje }}</span>
              <span style="float: right; color: var(--el-text-color-secondary); font-size: 13px">
                Paso: {{ desarrollo.Paso }} | Des: {{ desarrollo.Desarrollo }}
              </span>
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-descriptions
            size="default"
            title="Detalles del Cilindro"
            border
          >
            <el-descriptions-item label="Engranaje">{{
              cylinder.Desarrollo.Engranaje
            }}</el-descriptions-item>
            <el-descriptions-item label="Paso">{{ cylinder.Desarrollo.Paso }}</el-descriptions-item>
            <el-descriptions-item label="Desarrollo">{{
              cylinder.Desarrollo.Desarrollo
            }}</el-descriptions-item>
          </el-descriptions>
        </el-col>
      </el-row>
    </div>

    <div class="container">
      <custom-confirm-buttons
        :disabled="false"
        :showLoading="false"
        :confirmText="'Guardar'"
        :cancelText="'Cancelar'"
        @on-cancel="onCancel"
        @on-confirm="onConfirm"
      ></custom-confirm-buttons>
    </div>
  </el-dialog>
</template>

<script setup>
import {
  ref,
  onBeforeMount,
  reactive,
} from 'vue';
import { useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useCilindroTipoStore } from '@/stores/cilindro-tipo/cilindro-tipo';
import { useCylinderStore } from '../stores/cylinders_store.js';
import { useDesarrolloStore } from '@/stores/desarrollo/desarrollo_store.js';
import CustomConfirmButtons from '@/shared/components/custom_confirm_buttons.vue';
import CustomSelect from '@/shared/components/custom_select.vue';
import CustomInputNumber from '@/shared/components/custom_input_number.vue';
import { Desarrollo } from '../models/cylinder_model.js';
import { useMessageError } from '@/shared/composables/message_error.js';
import { useMessageSuccess } from '@/shared/composables/message_success.js';
import { useLoading } from '@/shared/composables/loading.js';
import { ElNotification } from 'element-plus';

const cilindroTipoStore = useCilindroTipoStore();
const cylinderStore = useCylinderStore();
const desarrolloStore = useDesarrolloStore();
const { findAllDesarrollos, searchDesarrolloHTTP } = desarrolloStore;
const { resetCilindros, validarCampos, resetValidations, newDesarrolloCilindroTipoHTTP } =
  cylinderStore;
const { firstCilindroTipo } = cilindroTipoStore;
const { cilindroTipoList } = storeToRefs(cilindroTipoStore);
const { cylinder, validateCylinderFields } = storeToRefs(cylinderStore);
const { desarrollos } = storeToRefs(desarrolloStore);
const emit = defineEmits(['closed']);
const modalVisible = ref(false);
const isLoading = ref(false);
const error = {
  message: 'Ya existe un registro con la información ingresada',
};
const closeModal = () => {
  modalVisible.value = false;
  emit('closed');
};

const onCancel = () => {
  resetCilindros();
  resetValidations();
  closeModal();
};

const fetchEngranaje = async (query) => {
  if (!query) return;
  isLoading.value = true;
  try {
    // Simulación de una búsqueda asincrónica, reemplaza esto con tu llamada API.
    desarrollos.value = await searchDesarrolloHTTP(query);
  } catch (error) {
    console.error('Error fetching engranaje:', error);
  } finally {
    isLoading.value = false;
  }
};
function handleEnganajeChange(codigoSeleccionado) {
  if (codigoSeleccionado) {
    const seleccion = desarrollos.value.find((d) => d.Codigo === codigoSeleccionado);

    if (seleccion) {
      cylinder.value.CodigoDesarrollo = seleccion.Codigo;
      cylinder.value.Desarrollo = seleccion;
    }
  } else {
    cylinder.value.Desarrollo = { ...Desarrollo };
    cylinder.value.CodigoDesarrollo = null;
  }
}

function handleTipoCilindroChange(item) {
  cylinder.value.CodigoCilindroTipo = item.Codigo;
}

onBeforeMount(() => {
  firstCilindroTipo();
  findAllDesarrollos();
});

const onConfirm = async () => {
  if (!validarCampos()) {
    ElNotification({
      title: 'Cilindros',
      message: 'Por favor, completar los campos obligatorios',
      type: 'warning',
    });
    return;
  } else {
    try {
      useLoading().openLoading();
      await newDesarrolloCilindroTipoHTTP();
      useMessageSuccess().open('Los datos se han guardado exitosamente!');
      closeModal();
    } catch (err) {
      error.message = err.response?.data?.message || 'Hubo un error';
      console.log(error);
      useMessageError().open(error);
    } finally {
      useLoading().closeLoading();
    }
  }
};
</script>

<style scoped>
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  margin: 5%;
}

/* Elimina los márgenes de los el-form-item */
.el-form-item {
  margin-top: 0;
  margin-bottom: 2%;
}

.input-margin {
  margin-top: 3%;
}

.full-width {
  width: 100%;
}

.custom-label {
  font-weight: 700;
  color: #111;
}

.container {
  display: flex;
  justify-content: flex-end;
  /* Alinea todo el contenido al final del contenedor */
}
</style>
